import { AxiosResponse } from "axios";
import API from "../api";
import { MemberTimesheet } from "../models/members/member.timesheet";
import { Options } from "./_base";
import BaseService from "./_base.service";
import { TimesheetWidgets } from "../types";

const endpoint = "timesheet";

const TimesheetService = {
  ...BaseService<MemberTimesheet>({ endpoint }),
  async getWidgets(options: Options<MemberTimesheet>): Promise<AxiosResponse<TimesheetWidgets>> {
    return await API.get(`${endpoint}/widgets`, { params: options });
  },
};

export default TimesheetService;
